import { Text, View } from "@react-pdf/renderer";
import React from "react";

export interface DocumentDetailSectionProps
  extends React.HTMLAttributes<HTMLElement> {
  sectionTitle?: string;
  noBorderBottom?: boolean;
}

const DocumentDetailSection = ({
  sectionTitle,
  children,
}: DocumentDetailSectionProps) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "2.5mm",
      }}
    >
      {sectionTitle && (
        <Text
          style={{
            color: "",
            fontFamily: "Pretendard",
            fontSize: "12pt",
            fontWeight: 600,
          }}
        >
          {sectionTitle}
        </Text>
      )}

      <View
        style={{
          display: "flex",
          flexDirection: "column",
          borderTop: "0.5mm solid #6D757F",
        }}
      >
        {children}
      </View>
    </View>
  );
};

export default DocumentDetailSection;
